import React, { FC } from 'react';
import { TextField } from '@mui/material';

import { useTranslate } from 'src/shared/providers';

interface Props {
  note: string;
  onChange: (notes: string) => void;
}

export const AbsenceNotesInput: FC<Props> = ({ note, onChange }) => {
  const { t } = useTranslate();

  return (
    <>
      <label className="small mb-2 fw-medium d-block">{t('absences.leaveANote')}</label>
      <TextField
        value={note}
        onChange={(event) => onChange(event.target.value)}
        className="w-75 rounded"
        minRows={4}
        maxRows={4}
        multiline
        aria-label="maximum height"
        placeholder={t('absences.enterANoteHere')}
        inputProps={{ maxLength: 1000 }}
      />
    </>
  );
};
